
import {Vue, Component} from 'vue-property-decorator';
import SetTableColumns from "@/components/SetTableColumns.vue";
import {integrityApi} from "@/api/integrity";
import {mechanismApi} from "@/api/organization";

@Component({

})
export default class Confirm extends Vue {
  fullScreen = false;
  form_data = {};
  userData = this.$store.state.AuthedUser;

  mounted() {
    if(this.$route.path == "/cxjl/confirm/do"){
      this.fullScreen = true;
    }
    this.getData(this.userData?this.userData.organizationId:0);
  }

  getData(orgId: number){
    mechanismApi.getMechanismAndUser(orgId).then((res:any) => {
      this.form_data = res.data.data;
    }).catch((err:any)=>{
      this.$message.error(err.msg);
    });
  }

  confirmClick(){
    integrityApi.mechanismConfirm({
      orgId: this.userData?this.userData.organizationId:0
    }).then((res:any) => {
      this.$message.success("确认成功！");
    }).catch((err:any)=>{
      this.$message.error(err.msg);
    });
  }
}
